import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ListUsers, User, UserCreate } from 'src/models/User.interface';
import { NewPasswordUser } from 'src/models/newPasswordUser.interface';

@Injectable({
  providedIn: 'root',
})
export class UsersService {

  public rolEmitter: EventEmitter<string> = new EventEmitter();
  private apiUrl = `${environment.API_URL}/api/v1/users`;

  constructor(private http: HttpClient) { }

  getListUsers(page: number): Observable<ListUsers> {
    const url = `${this.apiUrl}?page=${page}`;
    return this.http.get<ListUsers>(url);
  }

  createUser(newUser: UserCreate): Observable<any> {
    return this.http.post(this.apiUrl, newUser);
  }

  changePassword(newPasswordUser: NewPasswordUser): Observable<any> {
    const url = `${this.apiUrl}/password`;
    return this.http.patch(url, newPasswordUser);
  }

  changeUserRole(user: User): Observable<any> {
    const url = `${this.apiUrl}/${user.id}/role`;
    return this.http.patch<User>(url, { role: user.role });
  }

  deleteUser(user: User): Observable<string[]> {
    const url = `${this.apiUrl}/${user.id}`;
    return this.http.delete<string[]>(url);
  }

  getUserInfo(): Observable<any> {
    const url = `${this.apiUrl}/info`;
    return this.http.get(url);
  }
}

